// ==========================================================================
// groots Starter Kit
// Author: Globalia
// Licensed under the WTFPL license
// ==========================================================================

// Groots Core !! DO NOT DELETE !!
require('_groots.js');

// Display debug informations
window.groots.verbose = process.env.NODE_ENV === 'production' ? true : false;

// Require Groots JS-Plugins
window.groots.plugins = {
    grAccTabs:           require('grAccTabs/grAccTabs.js'),
    grDropdown:          require('grDropdown/grDropdown.js'),
    grEqualizer:         require('grEqualizer/grEqualizer.js'),
    grFormUpload:        require('grFormUpload/grFormUpload.js'),
    grFormNormalize:     require('grFormNormalize/grFormNormalize.js'),
    grFormValidation:    require('grFormValidation/grFormValidation.js'),
    grGoogleMap:         require('grGoogleMap/grGoogleMap.js'),
    grGridExpander:      require('grGridExpander/grGridExpander.js'),
    grLazyLoader:        require('grLazyLoader/grLazyLoader.js'),
    grNavigation:        require('grNavigation/grNavigation.js'),
    grObjectfitEmulator: require('grObjectfitEmulator/grObjectfitEmulator.js'),
    grScrollTo:          require('grScrollTo/grScrollTo.js'),
    grSVGInliner:        require('grSVGInliner/grSVGInliner.js'),
    grTable:             require('grTable/grTable.js'),
    grVideoYoutube:      require('grVideoYoutube/grVideoYoutube.js')
}; // Remove plugins you don't use from this array to not include them in your project

// ==========================================================================
// Custom Scripts
// ==========================================================================


(function() {
    'use strict';

    require('./_slick.js');
    require('./_header.js');
    require('./_industry.js');
    //require('./_google-map.js');
})();
